<template>
  <div>
    <PageAllow controller="Receipt" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <!-- 要货商/供应商 -->
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("ReceiptDetail.title") }}
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="$permission.permissionAllow('Receipt', 'detailExport')"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="download()"
                >
                  <v-icon x-small class="pe-1">fa-file-export</v-icon>
                  {{ $t("ReceiptDetail.receipt_detail_export") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />

          <v-expansion-panel-content>
            <v-row
              no-gutters
              class="mt-4 table-style"
              v-if="billEntity.bill_obj_type == 1"
            >
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("ReceiptDetail.Fields.importers", [
                        $consts.shopName(),
                      ])
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{
                      billEntity.shop.shop_name +
                      "(" +
                      billEntity.shop.shop_code +
                      ")"
                    }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.name }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_number")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.tel }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              class="mt-4 table-style"
              v-if="billEntity.bill_obj_type == 2"
            >
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.supplier")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.supplier">
                    {{
                      billEntity.supplier.supplier_name +
                      "(" +
                      billEntity.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.name }}
                  </span>
                  <span v-else> </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ReceiptDetail.Fields.tel_number")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span v-if="billEntity.shop">
                    {{ billEntity.shop.shop_user.tel }}
                  </span>
                  <span v-else> </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- 收付款流水 + 活动记录 -->
      <v-expansion-panels
        v-model="panelsDetail"
        multiple
        accordion
        class="mt-4"
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("ReceiptDetail.Fields.turnover") }}
              <v-spacer />
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />
          <v-expansion-panel-content>
            <v-card-text>
              <!-- 101 202 -->
              <v-row
                dense
                v-if="
                  billEntity.bill_type == 101 || billEntity.bill_type == 202
                "
              >
                <v-col cols="12" sm="6" md="3" class="text-no-wrap">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.bill_check_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.bill_code }}</span>
                  <v-chip
                    v-if="billEntity.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.credential_type")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.credential_str }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.fee_total")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ $t("Global.money") }}
                    {{ billEntity.total_price | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.net_receipt")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ $t("Global.money") }}
                    {{
                      (billEntity.up_sum - billEntity.down_sum) | formatMoney
                    }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span v-if="billEntity.wait_io_type == 3">
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.waite_refund")
                      }}{{ $t("Global.colon") }}</span
                    >
                    {{ $t("Global.money") }}
                    {{ billEntity.wait_pay_price | formatMoney }}
                  </span>
                  <span v-else>
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.wait_receive")
                      }}{{ $t("Global.colon") }}</span
                    >
                    {{ $t("Global.money") }}
                    {{ billEntity.wait_receive_price | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2" v-if="billEntity.pay_type == 1">
                  <span>
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.personal_pay")
                      }}{{ $t("Global.colon") }}</span
                    >
                    {{ $t("Global.money") }}
                    {{ billEntity.personal_pay_price | formatMoney }}
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  v-if="billEntity.bill_type == 101 && billEntity.return_price"
                >
                  <span>
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.refund_sum")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ $t("Global.money") }}
                    {{ billEntity.return_price | formatMoney }}
                  </span>
                </v-col>
              </v-row>
              <!-- 102 201 -->
              <v-row
                dense
                v-if="
                  billEntity.bill_type == 102 || billEntity.bill_type == 201
                "
              >
                <v-col cols="12" sm="6" md="3" class="text-no-wrap">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.bill_check_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.bill_code }}</span>
                  <v-chip
                    v-if="billEntity.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.credential_type")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.credential_str }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.pay_fee_total")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ $t("Global.money") }}
                    {{ billEntity.total_price | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.paid_in")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ $t("Global.money") }}
                    {{
                      (billEntity.down_sum - billEntity.up_sum) | formatMoney
                    }}
                  </span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span v-if="billEntity.wait_io_type == 1">
                    <!-- billEntity.down_sum -
                        billEntity.up_sum -
                        billEntity.total_price >=
                      0 -->
                    <span
                      class="font-weight-bold me-2"
                      v-if="
                        billEntity.total_price <
                        billEntity.down_sum - billEntity.up_sum
                      "
                      >{{ $t("ReceiptDetail.waite_refund")
                      }}{{ $t("Global.colon") }}</span
                    >
                    <span class="font-weight-bold me-2" v-else
                      >{{ $t("ReceiptDetail.wait_receive")
                      }}{{ $t("Global.colon") }}</span
                    >
                    {{ $t("Global.money") }}
                    {{ billEntity.wait_receive_price | formatMoney }}
                  </span>
                  <span v-else>
                    <span class="font-weight-bold me-2"
                      >{{ $t("ReceiptDetail.wait_pay")
                      }}{{ $t("Global.colon") }}</span
                    >
                    {{ $t("Global.money") }}
                    {{ billEntity.wait_pay_price | formatMoney }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>

            <v-row no-gutters>
              <v-spacer />
            </v-row>
            <v-data-table :headers="headers" :items="bill_records">
              <template v-slot:item.voucher_code="{ item }">
                <span class="text-no-wrap">
                  {{ item.voucher_code }}
                </span>
              </template>

              <template v-slot:item.bill_record_code="{ item }">
                <div class="d-flex flex-row justify-end align-center">
                  <div class="mr-4">
                    <span v-if="item.operation_type == 203">
                      <v-chip
                        small
                        label
                        :color="item.operation_type | operationTypeColor"
                        :text-color="
                          item.operation_type | operationTypeTextColor
                        "
                      >
                        {{ item.operation_type | operationTypeText }}
                      </v-chip>
                    </span>
                    <span v-if="item.operation_type == 901">
                      <v-chip
                        small
                        label
                        :color="item.operation_type | operationTypeColor"
                        :text-color="
                          item.operation_type | operationTypeTextColor
                        "
                      >
                        {{ item.operation_type | operationTypeText }}
                      </v-chip>
                    </span>
                  </div>
                  <div>
                    <span class="text-no-wrap caption font-weight-bold">
                      {{ item.bill_record_code }}
                    </span>
                    <br />
                    <span
                      class="text-no-wrap caption secondary--text"
                      :class="
                        $vuetify.theme.dark
                          ? 'text--lighten-1'
                          : 'text--darken-1'
                      "
                    >
                      {{ item.created | formatTime }}
                    </span>
                  </div>
                </div>
              </template>
              <!-- 收款 -->
              <template v-slot:item.collection="{ item }">
                <span v-if="item.io_type == 1">
                  {{ $t("Global.money") }}{{ item.price | formatMoney }}
                </span>
              </template>
              <!-- 付款 -->
              <template v-slot:item.pay="{ item }">
                <span v-if="item.io_type == 2">
                  {{ $t("Global.money") }}{{ item.price | formatMoney }}
                </span>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- 活动记录 -->
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panelsDetail.find((p) => p == 1)
                    ? null
                    : panelsDetail.push(1);
                "
              >
                {{ $t("ReceiptDetail.activities.title") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="activities_details"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- 对账单明细 -->
      <v-expansion-panels v-model="Detail" multiple accordion class="mt-4">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("ReceiptDetail.Fields.receipt_detail") }}
              <span v-if="billEntity.bill_type == 101" class="pl-1">
                {{ "(" + $t("ReceiptDetail.Fields.requisition") + ")" }}
              </span>
              <span v-if="billEntity.bill_type == 102" class="pl-1">
                {{
                  "(" +
                  $t("ReceiptDetail.Fields.shop_return", [$consts.shopName()]) +
                  ")"
                }}
              </span>
              <span v-if="billEntity.bill_type == 201" class="pl-1">
                {{ "(" + $t("ReceiptDetail.Fields.purchase") + ")" }}
              </span>
              <span v-if="billEntity.bill_type == 202" class="pl-1">
                {{ "(" + $t("ReceiptDetail.Fields.purchase_return") + ")" }}
              </span>
              <v-spacer />
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />
          <v-expansion-panel-content>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="6" md="4" class="text-no-wrap">
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.obj") }}{{ $t("Global.colon") }}</span
                  >
                  <span v-if="billEntity.shop">
                    {{
                      billEntity.shop.shop_name +
                      "(" +
                      billEntity.shop.shop_code +
                      ")"
                    }}
                  </span>
                  <span v-if="billEntity.supplier">
                    {{
                      billEntity.supplier.supplier_name +
                      "(" +
                      billEntity.supplier.supplier_code +
                      ")"
                    }}
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="billEntity.bill_type == 101"
                >
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.org_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.org_code }}</span>
                  <v-chip
                    v-if="billEntity.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="billEntity.bill_type == 102"
                >
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.return_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.org_code }}</span>
                  <v-chip
                    v-if="billEntity.cancel_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="billEntity.bill_type == 201"
                >
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.in_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span
                    >{{ billEntity.org_code }}
                    <span v-if="billEntity.stock_order.bill_purchase">
                      (
                      {{ billEntity.stock_order.bill_purchase.purchase_code }}
                      )
                    </span>
                  </span>
                  <v-chip
                    v-if="billEntity.cancel_flg || billEntity.all_loss_flg"
                    small
                    label
                    outlined
                    color="danger"
                    class="ms-1 my-n1"
                    >{{ $t("CRUD.cancelled") }}
                  </v-chip>
                  <span v-if="billEntity.all_loss_flg" class="red--text">
                    [{{ $t("ReceiptDetail.Fields.normal_four") }}]
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="billEntity.bill_type == 202"
                >
                  <span class="font-weight-bold me-2"
                    >{{ $t("ReceiptDetail.out_code")
                    }}{{ $t("Global.colon") }}</span
                  >
                  <span>{{ billEntity.org_code }}</span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="billEntity.bill_obj_type == 1"
                >
                  <span class="font-weight-bold me-2">
                    {{ $t("ReceiptDetail.sum_price") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span
                    >{{ $t("Global.money")
                    }}{{ billEntity.fee | formatMoney }}</span
                  >
                  <span class="red--text">
                    (
                    {{
                      $t("ReceiptDetail.fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}</span
                  >
                  <span class="red--text"
                    >{{
                      (billEntity.fee - billEntity.logistics_fee) | formatMoney
                    }}
                    )
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="billEntity.bill_obj_type == 2"
                >
                  <span class="font-weight-bold me-2">
                    {{ $t("ReceiptDetail.sum_price_tax") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span
                    >{{ $t("Global.money")
                    }}{{ billEntity.total_price | formatMoney }}</span
                  >
                  <span class="red--text">
                    (
                    {{
                      $t("ReceiptDetail.fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}</span
                  >
                  <span class="red--text"
                    >{{ billEntity.fee | formatMoney }} )
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="8"
                  v-if="billEntity.bill_obj_type == 1"
                ></v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="billEntity.bill_obj_type == 1"
                >
                  <span class="transparent--text font-weight-bold me-2">
                    {{ $t("ReceiptDetail.sum_price") }}
                    {{ $t("Global.colon") }}
                  </span>
                  <span class="transparent--text">
                    {{ $t("Global.money")
                    }}{{ billEntity.fee | formatMoney }}</span
                  >
                  <span class="red--text">
                    (&nbsp;{{
                      $t("ReceiptDetail.logistics_fee") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}
                  </span>
                  <span class="red--text">
                    {{ billEntity.logistics_fee | formatMoney }}&nbsp;)
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="8"
                  v-if="
                    billEntity.gross_weight_total &&
                    billEntity.gross_weight_total != ''
                  "
                ></v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="
                    billEntity.gross_weight_total &&
                    billEntity.gross_weight_total != ''
                  "
                >
                  <span v-if="billEntity.bill_obj_type == 1">
                    <span class="transparent--text font-weight-bold me-2">
                      {{ $t("ReceiptDetail.sum_price") }}
                      {{ $t("Global.colon") }}
                    </span>
                    <span class="transparent--text">
                      {{ $t("Global.money") }}
                      {{ billEntity.fee | formatMoney }}
                    </span>
                  </span>
                  <span v-if="billEntity.bill_obj_type == 2">
                    <span class="font-weight-bold me-2">
                      {{ $t("ReceiptDetail.sum_price_tax") }}
                      {{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ $t("Global.money") }}
                      {{ billEntity.total_price | formatMoney }}
                    </span>
                  </span>
                  <span class="red--text">
                    (&nbsp;{{
                      $t("Order.DetailFields.gross_weight") + $t("Global.colon")
                    }}
                  </span>
                  <span class="red--text">
                    {{ billEntity.gross_weight_total }}&nbsp;)
                  </span>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              :headers="receiptHeaders"
              :items="bill_details"
              :search="search"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <v-row no-gutters class="me-n3">
                    <v-row no-gutters>
                      <v-spacer />
                      <v-col cols="12" sm="4" md="4">
                        <v-text-field
                          v-model="search"
                          clearable
                          hide-details
                          :label="$t('Search.filter')"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:item.standard_name="{ item }">
                <span
                  v-if="item.standard_name && item.standard_name.length > 12"
                  :title="item.standard_name"
                  style="cursor: pointer"
                  class="text-no-wrap"
                >
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else class="text-no-wrap">
                  {{ item.standard_name }}
                </span>
              </template>
              <template v-slot:item.price="{ item }">
                <span v-if="item.negotiate_price_flg == 1">
                  {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
                </span>
                <span v-else>
                  {{ $t("Global.money") }}{{ item.price | formatMoney }}
                </span>
              </template>
              <template v-slot:item.total_num="{ item }">
                <span>
                  {{ item.total_num | formatMoney }}
                </span>
              </template>
              <template v-slot:item.total_price="{ item }">
                <span v-if="item.negotiate_price_flg == 1">
                  {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
                </span>
                <span v-else>
                  {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
                </span>
              </template>
              <template v-slot:item.before_tax_price="{ item }">
                <span>
                  {{ $t("Global.money")
                  }}{{ item.before_tax_price | formatMoney }}
                </span>
              </template>
              <template v-slot:item.after_tax_price="{ item }">
                <span>
                  {{ $t("Global.money")
                  }}{{ item.after_tax_price | formatMoney }}
                </span>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Receipt from "@/api/receipt";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.receipt"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.receiptDetail"),
        disabled: true,
        href: "/receipts",
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("ReceiptDetail.Fields.bill_record_code"),
          align: "center",
          sortable: false,
          width: 220,
          value: "bill_record_code",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.pay_type_str"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "pay_type_str",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.collection"),
          align: "center",
          sortable: false,
          value: "collection",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.pay"),
          align: "center",
          sortable: false,
          value: "pay",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.voucher_code"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "voucher_code",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.comment"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "comment",
        },
      ];
      if (
        this.billEntity.bill_type == 102 &&
        this.billEntity.order_return_type == 2
      ) {
        headers.push({
          text: i18n.t("ReceiptDetail.Fields.origin_bill_record_code"),
          align: "center",
          sortable: false,
          value: "origin_bill_record_code",
        });
      }
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ReceiptDetail.activities.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ReceiptDetail.activities.Fields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ReceiptDetail.activities.Fields.operater_name"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    receiptHeaders() {
      var receiptHeaders = [
        {
          text: i18n.t("ReceiptDetail.Fields.material_code"),
          align: "center",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.material_name"),
          align: "center",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.standard_name"),
          align: "center",
          sortable: false,
          value: "standard_name",
        },
        {
          text: i18n.t("ReceiptDetail.Fields.unit"),
          align: "center",
          sortable: false,
          value: "unit",
        },
      ];
      if (
        this.accountSettings &&
        this.accountSettings.use_tax == 1 &&
        this.billEntity.bill_type == 201
      ) {
        receiptHeaders.push(
          {
            text: i18n.t("ReceiptDetail.Fields.before_tax_price"),
            align: "center",
            sortable: false,
            value: "before_tax_price",
          },
          {
            text: i18n.t("ReceiptDetail.Fields.after_tax_price"),
            align: "center",
            sortable: false,
            value: "after_tax_price",
          }
        );
      } else {
        receiptHeaders.push({
          text: i18n.t("ReceiptDetail.Fields.price"),
          align: "center",
          sortable: false,
          value: "price",
        });
      }
      receiptHeaders.push({
        text: i18n.t("ReceiptDetail.Fields.total_num"),
        align: "center",
        sortable: false,
        value: "total_num",
      });
      receiptHeaders.push({
        text: i18n.t("ReceiptDetail.Fields.total_price"),
        align: "center",
        sortable: false,
        value: "total_price",
      });
      if (
        this.accountSettings &&
        this.accountSettings.finance_bill_enable == 1
      ) {
        receiptHeaders.push({
          text: i18n.t("ReceiptDetail.Fields.finance_memo"),
          align: "center",
          sortable: false,
          filterable: false,
          value: "finance_memo",
        });
      }
      return receiptHeaders;
    },
    accountID() {
      return this.accountInfo ? this.accountInfo.account_id : "";
    },
    ...mapState(["accountSettings", "accountInfo"]),
  },

  data: () => ({
    currentItem: {},
    currentItemLock: {},
    bill_record_time: new Date().toISOString().substr(0, 10),
    // pay_type: 101,
    pay_price: 0,
    wait_pay_price: 0,

    panels: [0],
    panelsDetail: [0],
    Detail: [0],
    tab: null,
    billEntity: {},
    order_activities: [],
    bill_records: [],
    bill_details: [],
    activities_details: [],
    search: "",
    return_price: null,
    price: null,
  }),

  mounted() {
    this.getReceiptDetailsFromAPI();
  },

  watch: {},

  methods: {
    getReceiptDetailsFromAPI() {
      Receipt.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.billEntity = response.data.billEntity;
            this.bill_records = response.data.billEntity.bill_records;
            this.bill_details = response.data.billEntity.bill_details;
            this.activities_details = response.data.order_activities;
          }
        }.bind(this)
      );
    },
    // 对账单详情导出
    download() {
      Receipt.download(
        Object.assign({
          id: this.$route.params.id,
          time_type: this.$route.query.time_type,
        })
      );
    },
  },
};
</script>

<style>
</style>